// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1CC39"};